import { createContext, useContext } from 'react';

interface AboutContextValue {
  openAbout: () => void;
}

export const AboutContext = createContext<AboutContextValue>({
  openAbout: () => undefined,
});

export function useAbout() {
  return useContext(AboutContext);
}
